// remove all query params from url

function removeQueryParams() {
  var url = window.location.href.split("?")[0];
  window.history.replaceState({}, document.title, url);
}

class WatchConfigurator extends HTMLElement {
  constructor() {
    super();

    // init all vars and events

    this.initVars();
    this.initEvents();
    this.initSwiperSliders();
    this.initFooter();
    this.checkIfHasSelection();
    this.sortSwiperSlideStrap();
  }

  sortSwiperSlideStrap(family, size) {
    // open loader
    if (this.isOpen) {
      setTimeout(
        function () {
          this.querySelector(
            ".watch-configurator-alert-simple-loader-config"
          ).classList.remove("opened", "opacity-20");
          this.querySelector(".watch-configurator__view3").setAttribute(
            "style",
            "opacity: 1"
          );
        }.bind(this),
        1400
      );
    }
    document
      .querySelectorAll(
        ".watch-configurator-strap__container [data-strap-size]"
      )
      .forEach((item) => {
        item.remove();
      });

    this.allStrapSlide.forEach((item) => {
      if (
        item.dataset.strapFamily == family &&
        item.dataset.strapSize == size &&
        item.dataset.clasp == "Acier"
      ) {
        item
          .querySelector("img")
          .setAttribute(
            "src",
            item.querySelector("img").getAttribute("data-src")
          );
        item.classList.remove("lazyload");
        item.removeAttribute("loading");
        document
          .querySelector(".watch-configurator-strap__container .swiper-wrapper")
          .appendChild(item);
      }
    });
    document
      .querySelectorAll(
        ".watch-configurator-strap__container [data-strap-size]"
      )
      .forEach((item) => {
        item.classList.remove("hidden", "swiper-slide-active");
        item.classList.add("swiper-slide");
      });
    this.updateDataInjectHTML();

    let additionalStrap2 = document.querySelector(
      '[data-additionnal-strap="2"]'
    );
    document.querySelector('[data-additionnal-strap="2"]')
      ? additionalStrap2.remove()
      : null;

    if (this.strap_card_selected) {
      this.querySelector(
        ".watch-configurator-strap__container .swiper-wrapper"
      ).appendChild(this.strap_card_selected);
    }

    //Move the additional strap 2 to the end of the list
    if (additionalStrap2) {
      document
        .querySelector(".watch-configurator-strap__container .swiper-wrapper")
        .appendChild(additionalStrap2);
    }

    this.selectStrapBtn = document.querySelectorAll(
      '[data-action="select-strap"]'
    );

    this.additionalStrapBtn = document.querySelectorAll(
      '[data-action="additional:strap"]'
    );

    this.selectAdditionalStrapBtn = document.querySelectorAll(
      '[data-action="additional:strap:add"]'
    );

    this.removeAdditionalStrapBtn = document.querySelectorAll(
      '[data-action="additional:strap:remove"]'
    );

    this.modifyAdditionalStrapBtn = document.querySelectorAll(
      '[data-action="additional:strap:modify"]'
    );

    this.cancelAdditionalStrapBtn = document.querySelectorAll(
      '[data-action="additional:strap:cancel"]'
    );

    this.modifyClaspBtn = document.querySelectorAll(
      '[data-action="clasp:modify"]'
    );

    this.clapsSlides = document.querySelectorAll(
      ".watch-configurator-clasps__select-metal"
    );

    this.clapsSelectBtn = document.querySelectorAll(
      '[data-action="clasp:select"]'
    );

    this.additionnalModifyStrapBtn = document.querySelectorAll(
      '[data-action="additionnal:clasp:modify"]'
    );

    this.additionalStrapSelectBtn = document.querySelectorAll(
      '[data-action="additionnal:clasp:select"]'
    );

    this.updateClassCollection();
    let clasp_data = window.claspCollection.find(function (clasp) {
      let handle = document
        .querySelector("[data-dial].selected")
        .dataset.dial.toLowerCase()
        .replaceAll(" ", "-");
      let claspHandle = clasp.handle.replaceAll("configurateur-boucle-", "");
      console.log(claspHandle, handle);
      return claspHandle === handle;
    });

    let clasp_data_additional = window.claspCollection.find(function (clasp) {
      let handle = "configurateur-boucle-acier";
      return clasp.handle === handle;
    });
    this.updateClaspData(clasp_data, clasp_data_additional);
    this.strapItems.forEach((item) =>
      item.addEventListener("click", this.slideToStrap.bind(this))
    );

    this.selectStrapBtn.forEach((btn) =>
      btn.addEventListener("click", this.selectStrap.bind(this))
    );

    this.querySelectorAll(".watch-configurator-strap__selected-dial").forEach(
      (item) => {
        item.setAttribute(
          "style",
          "background-image: url(" + this.dialPicture + ")"
        );
      }
    );

    this.strap_swiper.update();
  }

  updateDataSrc() {
    this.querySelectorAll("[data-src]").forEach((item) => {
      item.setAttribute("src", item.getAttribute("data-src"));
      item.removeAttribute("loading");
    });
  }

  initVars() {
    this.finalImageUrl = null;
    this.allStrapSlide = document.querySelectorAll(
      ".watch-configurator-strap__container [data-strap-size]"
    );

    this.isOpen = false;
    this.alertPopin = document.querySelector(
      ".watch-configurator-alert--collections"
    );
    this.alertPopinDials = document.querySelector(
      ".watch-configurator-alert--dials"
    );

    this.alertPopinContinueBtn = document.querySelector(
      ".watch-configurator-alert--collections .watch-configurator-alert__continue"
    );
    this.alertPopinCancelBtn = document.querySelectorAll(
      ".watch-configurator-alert__cancel"
    );

    this.alertPopinContinueBtnDials = document.querySelector(
      ".watch-configurator-alert--dials .watch-configurator-alert__continue"
    );

    this.currentStep = "collection";

    // Init selection object content to store the user configuration
    this.selection = {
      collection: null,
      strap: {},
      dial: null,
      strapOnlyPicture: null,
      clasp: null,
      additionalStrap: {
        1: null,
        2: null,
      },
    };

    this.collectionItems = document.querySelectorAll(
      ".watch-configurator__collection-item"
    );

    this.openConfiguratorBtn = document.querySelectorAll(
      '[data-action="open-configurator"]'
    );

    this.closeConfiguratorBtn = document.querySelectorAll(
      '[data-action="close-configurator"]'
    );

    this.selectCollectionBtn = document.querySelectorAll(
      '[data-action="select-collection"]'
    );

    this.selectDialBtn = document.querySelectorAll(
      '[data-action="select-dial"]'
    );

    this.configuratorFooter = document.querySelector(
      ".watch-configurator-footer"
    );

    this.dialItems = document.querySelectorAll(
      ".swiper-slide[data-dial-collection]"
    );

    this.strapItems = document.querySelectorAll(
      "[data-strap-color][data-strap-family]"
    );

    this.selectStrapBtn = document.querySelectorAll(
      '[data-action="select-strap"]'
    );

    this.additionalStrapBtn = document.querySelectorAll(
      '[data-action="additional:strap"]'
    );

    this.selectAdditionalStrapBtn = document.querySelectorAll(
      '[data-action="additional:strap:add"]'
    );

    this.removeAdditionalStrapBtn = document.querySelectorAll(
      '[data-action="additional:strap:remove"]'
    );

    this.modifyAdditionalStrapBtn = document.querySelectorAll(
      '[data-action="additional:strap:modify"]'
    );

    this.cancelAdditionalStrapBtn = document.querySelectorAll(
      '[data-action="additional:strap:cancel"]'
    );

    this.modifyClaspBtn = document.querySelectorAll(
      '[data-action="clasp:modify"]'
    );

    this.clapsSlides = document.querySelectorAll(
      ".watch-configurator-clasps__select-metal"
    );

    this.clapsSelectBtn = document.querySelectorAll(
      '[data-action="clasp:select"]'
    );

    this.additionnalModifyStrapBtn = document.querySelectorAll(
      '[data-action="additionnal:clasp:modify"]'
    );

    this.additionalStrapSelectBtn = document.querySelectorAll(
      '[data-action="additionnal:clasp:select"]'
    );

    this.body = document.querySelector("body");
  }

  initEvents() {
    /*
     * 1. Open the configurator
     * 2. Close the configurator
     * 3. Select a collection
     * 4. Select a strap
     * 5. Select a dial
     * 6. Add to cart -- TODO
     * 7. Continue to the next step popin alert
     * 8. Cancel the popin alert
     */
    this.openConfiguratorBtn.forEach((btn) =>
      btn.addEventListener("click", this.openWatchConfigurator.bind(this))
    );

    this.closeConfiguratorBtn.forEach((btn) =>
      btn.addEventListener("click", this.closeWatchConfigurator.bind(this))
    );

    this.selectCollectionBtn.forEach((btn) =>
      btn.addEventListener("click", this.selectCollection.bind(this))
    );

    this.querySelectorAll(".watch-configurator__collection-item").forEach(
      (item) =>
        item.addEventListener("click", this.slideToCollection.bind(this))
    );

    this.dialItems.forEach((item) =>
      item.addEventListener("click", this.slideToDial.bind(this))
    );

    this.selectDialBtn.forEach((btn) =>
      btn.addEventListener(
        "click",
        async function (e) {
          document
            .querySelector(".watch-configurator-alert-simple-loader-config")
            .classList.add("opened", "opacity-20");

          let that = this;
          setTimeout(
            function () {
              that.selectDial(e);
            }.bind(this),
            200
          );

          setTimeout(function () {
            document
              .querySelector(".watch-configurator-alert-simple-loader-config")
              .classList.remove("opened", "opacity-20");
          }, 1000);
        }.bind(this)
      )
    );

    this.strapItems.forEach((item) =>
      item.addEventListener("click", this.slideToStrap.bind(this))
    );

    this.selectStrapBtn.forEach((btn) =>
      btn.addEventListener("click", this.selectStrap.bind(this))
    );

    this.alertPopinCancelBtn.forEach((btn) => {
      btn.addEventListener("click", this.closeAlertPopin.bind(this));
    });

    this.alertPopinContinueBtn.addEventListener(
      "click",
      this.ResetToCollection.bind(this)
    );

    this.alertPopinContinueBtnDials.addEventListener(
      "click",
      this.ResetToDials.bind(this)
    );

    this.additionalStrapBtn.forEach((btn) =>
      btn.addEventListener("click", this.addStrap.bind(this))
    );

    this.selectAdditionalStrapBtn.forEach((btn) =>
      btn.addEventListener("click", this.selectAdditionalStrap.bind(this))
    );

    this.removeAdditionalStrapBtn.forEach((btn) =>
      btn.addEventListener("click", this.removeAdditionalStrap.bind(this))
    );

    this.modifyAdditionalStrapBtn.forEach((btn) =>
      btn.addEventListener("click", this.modifyAdditionalStrap.bind(this))
    );

    this.cancelAdditionalStrapBtn.forEach((btn) =>
      btn.addEventListener("click", this.cancelAdditionalStrap.bind(this))
    );

    this.modifyClaspBtn.forEach((btn) =>
      btn.addEventListener("click", this.modifyClasp.bind(this))
    );

    this.clapsSlides.forEach((slide) =>
      slide.addEventListener("click", this.slideToClaps.bind(this))
    );

    this.clapsSelectBtn.forEach((btn) =>
      btn.addEventListener("click", this.selectClasp.bind(this))
    );

    this.additionnalModifyStrapBtn.forEach((btn) =>
      btn.addEventListener("click", this.modifyClasp.bind(this))
    );

    this.additionalStrapSelectBtn.forEach((btn) =>
      btn.addEventListener("click", this.selectAditionnalClasp.bind(this))
    );

    this.querySelectorAll('[data-action="add-to-cart"]').forEach((button) => {
      button.addEventListener("click", this.addToCart.bind(this));
    });

    this.querySelectorAll(".watch-configurator__collection-item").forEach(
      (item) => {
        item.addEventListener("mouseover", (e) => {
          let handle = e.currentTarget.dataset.handle;
          this.querySelectorAll(".watch-configurator__collection-item").forEach(
            (item) => {
              item.classList.remove("hover");
            }
          );
          e.currentTarget.classList.add("hover");
          document
            .querySelectorAll(
              ".watch-configurator-footer__collection-list button"
            )
            .forEach((btn) => {
              btn.classList.remove("selected");
              if (btn.dataset.handle == handle) {
                btn.classList.add("selected");
              }
            });
        });

        // item.addEventListener("mouseout", (e) => {
        //   e.currentTarget.classList.remove("hover");
        //   document
        //     .querySelectorAll(
        //       ".watch-configurator-footer__collection-list button"
        //     )
        //     .forEach((btn) => {
        //       btn.classList.remove("selected");
        //     });
        // });
      }
    );

    document
      .querySelectorAll('[data-action="select-dial"]')
      .forEach((button) => {
        button.addEventListener("mouseenter", () => {
          document
            .querySelector(
              '.watch-configurator-diales__watch-title [data-action="select-dial"]'
            )
            .setAttribute(
              "style",
              "background: var(--color-primary); color: white; border-color: var(--color-primary);"
            );
        });
      });

    document
      .querySelectorAll('[data-action="select-dial"]')
      .forEach((button) => {
        button.addEventListener("mouseleave", () => {
          document
            .querySelector(
              '.watch-configurator-diales__watch-title [data-action="select-dial"]'
            )
            .setAttribute(
              "style",
              "background: var(--color-accent); color: white; border-color: var(--color-accent);"
            );
        });
      });

    document
      .querySelectorAll('[data-action="select-strap"]')
      .forEach((button) => {
        button.addEventListener("mouseenter", () => {
          document
            .querySelector(
              '.watch-configurator-strap__html-to-inject--main [data-action="select-strap"]'
            )
            .setAttribute(
              "style",
              "background: var(--color-primary); color: white; border-color: var(--color-primary);"
            );
        });
      });

    document
      .querySelectorAll('[data-action="select-strap"]')
      .forEach((button) => {
        button.addEventListener("mouseleave", () => {
          document
            .querySelector(
              '.watch-configurator-strap__html-to-inject--main [data-action="select-strap"]'
            )
            .setAttribute(
              "style",
              "background: var(--color-accent); color: white; border-color: var(--color-accent);"
            );
        });
      });

    document
      .querySelectorAll('[data-action="additional:strap:add"]')
      .forEach((button) => {
        button.addEventListener("mouseenter", () => {
          document
            .querySelector(
              '.watch-configurator-additional-strap--main [data-action="additional:strap:add"]'
            )
            .setAttribute(
              "style",
              "background: var(--color-primary); color: white; border-color: var(--color-primary);"
            );
        });
      });

    document
      .querySelectorAll('[data-action="additional:strap:add"]')
      .forEach((button) => {
        button.addEventListener("mouseleave", () => {
          document
            .querySelector(
              '.watch-configurator-additional-strap--main [data-action="additional:strap:add"]'
            )
            .setAttribute(
              "style",
              "background: var(--color-accent); color: white; border-color: var(--color-accent);"
            );
        });
      });

    this.querySelectorAll("[data-step-breadcrumb]").forEach((item) => {
      item.addEventListener("click", (e) => {
        let step = e.currentTarget.dataset.stepBreadcrumb;
        if (step == "dial" && e.currentTarget.classList.contains("actif")) {
          document.querySelector(".watch-configurator-footer__dials").click();
        } else if (
          step == "strap" &&
          e.currentTarget.classList.contains("actif")
        ) {
          document
            .querySelector(".watch-configurator-footer__strap-list")
            .click();
        } else if (
          step == "collection" &&
          e.currentTarget.classList.contains("actif")
        ) {
          document
            .querySelector(".watch-configurator-footer__collection")
            .click();
        }
      });
    });
  }

  initSwiperSliders() {
    /*
     * 1. Init the collection swiper
     * 2. Init the strap swiper
     * 3. Init the dial swiper
     * 4. Init the clasp swiper
     */
    this.collectionSwiper = new Swiper(".watch-configurator__collection", {
      slidesPerView: 1,
      spaceBetween: 24,
      centeredSlides: false,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      allowTouchMove: true,
      centerInsufficientSlides: true,
      preventClicks: true,
      preventClicksPropagation: true,
      touchMoveStopPropagation: false,
      a11y: false,
      threshold: 15,
      navigation: {
        nextEl: ".watch-configurator__view1 .swiper-button-next",
        prevEl: ".watch-configurator__view1 .swiper-button-prev",
      },
      pagination: {
        el: ".watch-configurator__view1 .swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        550: {
          slidesPerView: 2,
          spaceBetween: 24,
          allowTouchMove: true,
        },
        990: {
          slidesPerView: 3,
          spaceBetween: 24,
          allowTouchMove: true,
        },
        1140: {
          slidesPerView: 4,
          spaceBetween: 24,
          allowTouchMove: true,
        },
        1440: {
          slidesPerView: 5,
          spaceBetween: 24,
          allowTouchMove: true,
        },
        1920: {
          slidesPerView: 5,
          spaceBetween: 24,
          allowTouchMove: false,
        },
      },
    });

    this.dials_swiper = new Swiper(".watch-configurator-diales__container", {
      slidesPerView: "auto",
      spaceBetween: 24,
      centeredSlides: true,
      observer: true,
      a11y: false,
      observeParents: true,
      observeSlideChildren: true,
      preventClicksPropagation: true,
      touchMoveStopPropagation: false,
      allowTouchMove: true,
      preventClicks: true,
      threshold: 15,
      pagination: {
        el: ".watch-configurator__view2 .swiper-pagination",
      },
      navigation: {
        nextEl: ".watch-configurator__view2 .swiper-button-next",
        prevEl: ".watch-configurator__view2 .swiper-button-prev",
      },
      breakpoints: {
        1140: {
          allowTouchMove: true,
        },
      },
    });

    this.strap_swiper = new Swiper(".watch-configurator-strap__container", {
      slidesPerView: "auto",
      spaceBetween: 0,
      centeredSlides: true,
      observer: true,
      observeParents: true,
      a11y: false,
      observeSlideChildren: true,
      allowTouchMove: true,
      threshold: 15,
      preventInteractionOnTransition: true,
      clicToSelect: true,
      speed: 400,
      breakpoints: {
        1140: {
          allowTouchMove: true,
          spaceBetween: 24,
        },
      },
      navigation: {
        nextEl: ".watch-configurator__view3 .swiper-button-next",
        prevEl: ".watch-configurator__view3 .swiper-button-prev",
      },
      pagination: {
        el: ".watch-configurator__view3 .swiper-pagination",
      },
    });

    this.claps_swiper_container = this.querySelectorAll(
      ".watch-configurator-clasps__select"
    );
    this.claps_swiper_container.forEach((container) => {
      const swiper = new Swiper(container, {
        slidesPerView: 3.3,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        allowTouchMove: true,
        preventClicksPropagation: false,
        touchMoveStopPropagation: true,
        centeredSlides: true,
        slideToClickedSlide: true,
        a11y: false,
        threshold: 5,
        direction: "vertical",
        initialSlide: 1,
        preventInteractionOnTransition: true,
        speed: 500,
      });
    });

    this.dials_swiper.on("slideChange", (e) => {
      setTimeout(
        function () {
          let info_container = document.querySelector(
            ".watch-configurator-diales > .watch-configurator-diales__watch-title"
          );
          let source = e.el.querySelector(
            ".swiper-slide-active:not(.hidden) .watch-configurator-diales__watch-title"
          );
          if (source) info_container.innerHTML = source.innerHTML;
        }.bind(this),
        300
      );
    });

    this.strap_swiper.on("slideChange", (e) => {
      let info_container = document.querySelector(
        ".watch-configurator-strap__html-to-inject--main .to-inject"
      );
      let source = e.slides[e.activeIndex]
        ? e.slides[e.activeIndex].querySelector(
            ".watch-configurator-strap__html-to-inject"
          )
        : null;

      if (info_container && source) {
        info_container.innerHTML = source.innerHTML;
      }

      // additional strap

      let info_container2 = document.querySelector(
        ".watch-configurator-additional-strap--main"
      );

      let source2 = e.slides[e.activeIndex]
        ? e.slides[e.activeIndex].querySelector(
            ".watch-configurator-additional-strap"
          )
        : null;

      if (info_container2 && source2) {
        info_container2.innerHTML = source2.innerHTML;
      }
    });

    this.dials_swiper.on("update", function (e) {
      let source = e.el.querySelector(
        ".swiper-slide-active:not(.hidden) .watch-configurator-diales__watch-title"
      );
      let info_container = document.querySelector(
        ".watch-configurator-diales > .watch-configurator-diales__watch-title"
      );

      console.log(e.el.querySelector(".swiper-slide-active"));

      if (source) {
        console.log(source, info_container);
        info_container.innerHTML = source.innerHTML;
      }
    });

    this.strap_swiper.on("update", function (e) {
      let source = e.el.querySelector(
        ".swiper-slide-active:not(.hidden) .watch-configurator-strap__html-to-inject"
      );
      let info_container = document.querySelector(
        ".watch-configurator-strap__html-to-inject--main .to-inject"
      );

      if (source) {
        info_container.innerHTML = source.innerHTML;
      }

      // additional strap

      let source2 = e.el.querySelector(
        ".swiper-slide-active:not(.hidden) .watch-configurator-additional-strap"
      );
      let info_container2 = document.querySelector(
        ".watch-configurator-additional-strap--main"
      );

      if (source2) {
        info_container2.innerHTML = source2.innerHTML;
      }
    });
  }

  openWatchConfigurator() {
    /*
     * 1. Add the open class to the configurator
     * 2. Add the overflow hidden class to the body to prevent scrolling
     * 3. Update the isOpen var
     */
    this.classList.add("watch-configurator--open");
    this.body.classList.add("overflow-hidden");
    this.isOpen = true;
  }

  closeWatchConfigurator() {
    /*
     * 1. Remove the open class from the configurator
     * 2. Add the overflow hidden class to the body to prevent scrolling
     * 3. Update the isOpen var
     * 4. Reset the current step
     */
    this.classList.remove("watch-configurator--open");
    this.body.classList.remove("overflow-hidden");
    this.isOpen = false;
    this.currentStep = "collection";
  }

  selectCollection(event) {
    /*
     * 1. Hide all collections
     * 2. Show the selected collection
     * 3. Add the selected class to the selected collection
     * 4. Show the footer
     * 5. Hide the title
     * 6. Update the current step
     * 7. Update the selection object
     */

    this.selection.collection =
      event.target.closest("[data-handle]").dataset.handle;

    let urlDrawedStrap =
      event.target.closest("[data-handle]").dataset.watchEmpty;
    this.querySelector(
      ".watch-configurator-diales__selected-watch"
    ).setAttribute("style", "background-image: url(" + urlDrawedStrap + ")");

    this.collectionItems.forEach((item) => item.classList.add("hidden"));
    this.currentStep = "collection-selected";
    this.selection.collection =
      event.target.closest("[data-handle]").dataset.handle;

    let size = event.target.closest("[data-handle]").dataset.size;

    this.selection.collection_size = size;
    this.selection.title =
      event.target.closest("[data-handle]").dataset.watchTitle;

    this.updateClassCollection();

    this.querySelectorAll(
      ".watch-configurator-footer__list.watch-configurator-footer__strap-list [data-handle]"
    ).forEach((item) => {
      let family = item.dataset.strapFamily.split(" ");
      family = family[family.length - 1];

      if (family == size) {
        item.classList.remove("hidden");
      } else {
        item.classList.add("hidden");
      }
    });

    this.querySelectorAll(
      ".watch-configurator-footer__dials-list-container"
    ).forEach((container) => {
      container.classList.add("hidden");
    });

    this.querySelector(
      `.watch-configurator-footer__dials-list-container[data-product-handle="${this.selection.collection}"]`
    ).classList.remove("hidden");

    this.querySelector(
      `.watch-configurator-footer__dials-list-container[data-product-handle="${this.selection.collection}"] button:first-child`
    ).click();

    this.selection.strapOnlyPicture =
      event.target.closest("[data-watch-empty]").dataset.watchEmpty;

    this.querySelectorAll(
      ".watch-configurator-footer__collection-list button[data-handle]"
    ).forEach((btn) => btn.classList.remove("selected"));

    this.querySelector(
      `.watch-configurator-footer__collection-list button[data-handle="${this.selection.collection}"]`
    ).classList.add("selected");

    event.target
      .closest(".watch-configurator__collection-item")
      .classList.remove("hidden");

    event.target
      .closest(".watch-configurator__collection-item")
      .classList.add("selected");

    this.configuratorFooter.classList.remove("hidden");

    this.querySelector(".watch-configurator__view1 h3").classList.add("hidden");

    this.updateDialsCollection();

    this.querySelector(".watch-configurator-footer-fullwidth").scrollTo({
      left: 150,
      behavior: "smooth",
    });

    this.querySelector(".watch-configurator-footer__dials").classList.remove(
      "events-none"
    );
  }

  updateClassCollection() {
    if (
      this.selection.title == "Ma première mini" ||
      this.selection.title == "Rive droite mini"
    ) {
      this.querySelector(
        ".watch-configurator-diales__selected-watch"
      ).classList.remove("grand", "normal");
      this.querySelector(
        ".watch-configurator-diales__selected-watch"
      ).classList.add("mini");
      this.querySelectorAll(".watch-configurator-strap__selected-dial").forEach(
        (item) => {
          item.classList.remove(
            "grand",
            "normal",
            "rive-droite",
            "rive-droite-mini"
          );
        }
      );
      this.querySelectorAll(".watch-configurator-strap__selected-dial").forEach(
        (item) => {
          item.classList.add("mini");
          if (this.selection.title.indexOf("Rive droite mini") > -1) {
            item.classList.add("rive-droite-mini");
          }
        }
      );
    } else if (
      this.selection.title == "Ma première" ||
      this.selection.title == "Rive droite"
    ) {
      this.querySelector(
        ".watch-configurator-diales__selected-watch"
      ).classList.remove("grand", "mini");
      this.querySelector(
        ".watch-configurator-diales__selected-watch"
      ).classList.add("normal");
      this.querySelectorAll(".watch-configurator-strap__selected-dial").forEach(
        (item) => {
          item.classList.remove(
            "grand",
            "mini",
            "rive-droite",
            "rive-droite-mini"
          );
        }
      );
      this.querySelectorAll(".watch-configurator-strap__selected-dial").forEach(
        (item) => {
          item.classList.add("normal");
          if (this.selection.title.indexOf("Rive droite") > -1) {
            item.classList.add("rive-droite");
          }
        }
      );
    } else {
      this.querySelector(
        ".watch-configurator-diales__selected-watch"
      ).classList.remove("mini", "normal");
      this.querySelector(
        ".watch-configurator-diales__selected-watch"
      ).classList.add("grand");
      this.querySelectorAll(".watch-configurator-strap__selected-dial").forEach(
        (item) => {
          item.classList.remove("mini", "normal");
        }
      );
      this.querySelectorAll(".watch-configurator-strap__selected-dial").forEach(
        (item) => {
          item.classList.add("grand");
        }
      );
    }
  }

  selectDial(event) {
    /*
     * 1. Hide all dials
     * 2. Show the selected dial
     * 3. Add the selected class to the selected dial
     * 4. Update the current step
     * 5. Update the selection object
     * 6. Update the dial picture in the strap swiper
     * 7. Get clasp data for the selected dial
     */

    let dial_collection = event.target.closest("[data-dial-collection]").dataset
      .dialCollection;
    let watch_collection = event.target.closest("[data-watch-collection]")
      .dataset.watchCollection;

    this.currentStep = "dial-selected";

    this.selection.dialPrice = event.target.closest(
      "[data-dial-collection]"
    ).dataset.dialPrice;

    this.selection.dial = event.target.closest(
      "[data-variant-title]"
    ).dataset.variantSku;

    this.dialPicture = event.target
      .closest("[data-variant-title]")
      .querySelector("img")
      .getAttribute("src");

    this.querySelectorAll(".watch-configurator-strap__selected-dial").forEach(
      (item) => {
        item.setAttribute(
          "style",
          "background-image: url(" + this.dialPicture + ")"
        );
      }
    );

    this.querySelectorAll(".swiper-slide[data-dial-collection]").forEach(
      (item) => {
        item.classList.add("hidden");
        item.classList.remove("swiper-slide");
      }
    );

    this.querySelector(
      '[data-variant-sku="' + this.selection.dial + '"]'
    ).classList.remove("hidden");

    this.querySelector(
      '[data-variant-sku="' + this.selection.dial + '"]'
    ).classList.add("swiper-slide", "selected");

    this.querySelector(".watch-configurator-footer__dials").classList.remove(
      "modify"
    );

    this.querySelector(".watch-configurator-footer__dials").classList.remove(
      "disabled"
    );

    this.querySelector(".watch-configurator-footer__strap").classList.remove(
      "events-none"
    );

    this.querySelectorAll(
      `[data-strap-size="${this.selection.collection_size}"] .watch-configurator-strap__html-to-inject:not(.watch-configurator-strap__html-to-inject--main)`
    ).forEach((item) => {
      item.innerHTML = this.querySelector(
        ".watch-configurator-diales__container .swiper-slide.swiper-slide-active .watch-configurator-diales__watch-title"
      ).innerHTML;
      let strap_title = item.dataset.strapTitle;
      let strapPrice =
        parseInt(item.closest("[data-strap-price]").dataset.strapPrice) / 100;

      item.querySelector(".watch-configurator-straps-details").innerHTML =
        '<p class="medium-text">' +
        strap_title +
        `<span data-clasp-selected></span>` +
        '<span class="strap-included"> - ' +
        strapPrice +
        "€</span></p>";

      let current_price = parseFloat(
        item
          .querySelector(".watch-configurator-straps-details + p")
          .dataset.cPrice.replace("€", "") == "INCLUS"
          ? 0
          : item
              .querySelector(".watch-configurator-straps-details + p")
              .dataset.cPrice.replace("€", "")
      );
      let new_price = current_price + parseFloat(strapPrice);
      item.querySelector(".watch-configurator-straps-details + p").innerHTML =
        "TOTAL : " + new_price + " €";
    });

    let clasp_data = window.claspCollection.find(function (clasp) {
      let handle = document
        .querySelector("[data-dial].selected")
        .dataset.dial.toLowerCase()
        .replaceAll(" ", "-");
      let claspHandle = clasp.handle.replaceAll("configurateur-boucle-", "");
      console.log(claspHandle, handle);
      return claspHandle === handle;
    });

    let clasp_data_additional = window.claspCollection.find(function (clasp) {
      let handle = "configurateur-boucle-acier";
      return clasp.handle === handle;
    });

    console.log("END2");

    console.log("BEGIN3");

    this.updateClaspData(clasp_data, clasp_data_additional);

    this.querySelectorAll(
      ".watch-configurator-footer__list.watch-configurator-footer__strap-list [data-handle]:not(.hidden)"
    )[0]
      ? this.querySelectorAll(
          ".watch-configurator-footer__list.watch-configurator-footer__strap-list [data-handle]:not(.hidden)"
        )[0].click()
      : null;

    console.log("END3");

    // scroll .watch-configurator-footer-fullwidth to end X

    let left =
      this.querySelector(
        ".watch-configurator-footer-fullwidth .watch-configurator-footer__strap"
      ).offsetLeft - 150;
    this.querySelector(".watch-configurator-footer-fullwidth").scrollTo({
      left: left,
      behavior: "smooth",
    });

    console.log(clasp_data);
  }

  updateDataInjectHTML() {
    this.querySelectorAll(
      `[data-strap-size="${this.selection.collection_size}"] .watch-configurator-strap__html-to-inject:not(.watch-configurator-strap__html-to-inject--main)`
    ).forEach((item) => {
      item.innerHTML = this.querySelector(
        ".watch-configurator-diales__container .swiper-slide.swiper-slide-active .watch-configurator-diales__watch-title"
      ).innerHTML;
      let strap_title = item.dataset.strapTitle;
      let strapPrice =
        parseInt(item.closest("[data-strap-price]").dataset.strapPrice) / 100;

      item.querySelector(".watch-configurator-straps-details").innerHTML =
        '<p class="medium-text">' +
        strap_title +
        `<span data-clasp-selected></span>` +
        '<span class="strap-included"> - ' +
        strapPrice +
        "€</span></p>";

      let current_price = parseFloat(
        item
          .querySelector(".watch-configurator-straps-details + p")
          .dataset.cPrice.replace("€", "") == "INCLUS"
          ? 0
          : item
              .querySelector(".watch-configurator-straps-details + p")
              .dataset.cPrice.replace("€", "")
      );
      let new_price = current_price + parseFloat(strapPrice);
      item.querySelector(".watch-configurator-straps-details + p").innerHTML =
        "TOTAL : " + new_price + " €";
    });
  }

  selectStrap(event) {
    /*
     * 1. Hide all straps
     * 2. Show the selected strap
     * 3. Add the selected class to the selected strap
     * 4. Update the current step
     * 5. Update the selection object
     */

    this.currentStep = "strap-selected";
    this.strapItems = document.querySelectorAll(
      "[data-strap-color][data-strap-family]"
    );
    this.strapItems.forEach((item) => {
      item.classList.add("hidden");
      item.classList.remove(
        "swiper-slide",
        "swiper-slide-next",
        "swiper-slide-prev",
        "swiper-slide-active"
      );
    });

    this.selection.strap.title =
      event.target.closest("[data-strap-color]").dataset.strapFamily +
      "-" +
      event.target.closest("[data-strap-color]").dataset.strapColor;

    this.selection.strap.price = parseInt(
      event.target.closest("[data-strap-color]").dataset.strapPrice
    );

    console.log(event.target.closest("[data-strap-color]"));
    console.log(this.selection.strap.price);

    this.selection.strap.sku = event.target
      .closest("[data-strap-color]")
      .dataset.strapSku.split(" + ")[0];

    console.log(this.selection.strap);

    let strap_card = this.querySelector(
      '[data-strap-family="' +
        event.target.closest("[data-strap-color]").dataset.strapFamily +
        '"][data-strap-color="' +
        event.target.closest("[data-strap-color]").dataset.strapColor +
        '"][data-strap-size="' +
        this.selection.collection_size +
        '"][data-clasp="Acier"]'
    );

    console.log(this.selection.collection_size);

    this.strap_card_selected = strap_card;

    strap_card.classList.remove("hidden");
    strap_card.classList.add("selected", "swiper-slide", "swiper-slide-active");

    this.querySelectorAll(
      ".watch-configurator__view3 .watch-configurator-breadcrumb"
    ).forEach((item) => {
      item.classList.add("hidden");
    });

    this.querySelector(".watch-configurator-footer__strap").classList.remove(
      "modify",
      "disabled"
    );

    this.querySelectorAll("[data-additionnal-strap]").forEach((item) => {
      item.classList.remove("hidden");
      item.classList.add("swiper-slide");
    });

    this.querySelector(
      ".watch-configurator-strap__html-to-inject--main"
    ).classList.add("hidden");

    this.querySelector(".watch-configurator-strap__container").classList.add(
      "selected"
    );

    this.querySelector(
      ".watch-configurator-strap > .overflow-strap"
    ).classList.add("hidden");

    setTimeout(
      function () {
        this.strap_swiper.slideTo(1);
        window.dispatchEvent(new Event("resize"));
        this.strap_swiper.update();
      }.bind(this),
      600
    );

    this.updateAddToCart(true);
  }

  updateAddToCart(bool) {
    if (bool) {
      var img1 = document.getElementById("img1");
      var img2 = document.getElementById("img2");

      let imageStrap = document
        .querySelector(
          ".selected[data-strap-sku][data-strap-color] .watch-configurator-strap__strap-image img"
        )
        .getAttribute("data-src");
      let imageDial = document
        .querySelector(
          ".selected[data-strap-sku][data-strap-color] .watch-configurator-strap__selected-dial"
        )
        .getAttribute("style")
        .split("url(")[1]
        .split(")")[0];

      img1.setAttribute("src", imageStrap);
      img2.setAttribute("src", imageDial);

      this.querySelectorAll('[data-action="add-to-cart"]').forEach((button) => {
        button.classList.add("actif");
      });
    } else {
      this.querySelectorAll('[data-action="add-to-cart"]').forEach((button) => {
        button.classList.remove("actif");
      });
    }
  }

  returnSelectCollection() {
    /*
     * 1. Show all collections
     * 2. Remove the selected class from all collections
     * 3. Hide the footer
     * 4. Show the title
     */
    this.collectionItems.forEach((item) => item.classList.remove("hidden"));
    this.collectionItems.forEach((item) => item.classList.remove("selected"));
    this.configuratorFooter.classList.add("hidden");
    this.querySelector(".watch-configurator__view1 h3").classList.remove(
      "hidden"
    );
    this.updateAddToCart(false);
  }

  slideToCollection(event) {
    /*
     * 1. Get the handle of the collection
     * 2. Get the element of the collection
     * 3. Get the index of the element
     * 4. Slide to the index
     */
    let handle = event.target.closest("[data-handle]").dataset.handle;
    let element = this.querySelector(`.swiper-slide[data-handle="${handle}"]`);
    console.log(element);
    console.log(`.swiper-slide[data-handle="${handle}"] `);

    let index_to_slide = [...element.parentNode.children].indexOf(element);

    if (
      document.querySelector(".watch-configurator-footer__collection.modify")
    ) {
      this.querySelector(
        '[data-action="select-collection:modify"][data-handle="' + handle + '"]'
      ).click();
    }

    this.collectionSwiper.slideTo(index_to_slide, 300, false);
  }

  slideToDial(event) {
    /*
     * 1. Get the handle of the dial
     * 2. Get the element of the dial
     * 3. Get the index of the element
     * 4. Slide to the index
     */
    let sku = event.target.closest("[data-variant-sku]").dataset.variantSku;
    let element = this.querySelector(
      `.swiper-slide[data-variant-sku="${sku}"]`
    );

    console.log(element);
    console.log(`.swiper-slide[data-variant-sku="${sku}"] `);

    let index_to_slide = 0;
    let index = 0;
    if (element) {
      for (let i = 0; i < element.parentNode.children.length; i++) {
        if (element.parentNode.children[i].classList.contains("swiper-slide")) {
          if (element.parentNode.children[i].dataset.variantSku === sku) {
            index_to_slide = index;
          }
          index++;
        }
      }
    }

    this.dials_swiper.slideTo(index_to_slide, 300, false);
  }

  slideToStrap(event) {
    /*
     * 1. Get the family of the strap
     * 2. Get the element of the strap
     * 3. Get the index of the element
     * 4. Slide to the index
     */

    let family = event.currentTarget.dataset.strapFamily;
    let color = event.currentTarget.dataset.strapColor;

    let index_to_slide = 0;
    let index = 0;
    for (let i = 0; i < event.currentTarget.parentNode.children.length; i++) {
      let element = event.currentTarget.parentNode.children[i];
      if (element.classList.contains("swiper-slide")) {
        if (
          element.dataset.strapColor === color &&
          element.dataset.strapFamily === family
        ) {
          index_to_slide = index;
        }
        index++;
      }
    }

    this.strap_swiper.slideTo(index_to_slide, 300, false);
  }

  initFooter() {
    /*
     * 1. Add event to the collection button
     * 2. Add event to the strap button
     * 3. Add event to the dial button
     * 4. Add event to the button select collection
     */

    this.querySelector(
      ".watch-configurator-footer__collection"
    ).addEventListener("click", () => {
      if (
        this.currentStep === "dial-selected" ||
        this.currentStep === "strap-selected" ||
        this.currentStep === "strap-modify"
      ) {
        this.alertPopin.classList.add("opened");
      } else {
        this.querySelectorAll(
          ".watch-configurator__view3 .watch-configurator-breadcrumb"
        ).forEach((item) => {
          item.classList.remove("hidden");
        });
        this.currentStep = "collection-modify";
        this.updateStep();
        this.collectionItems.forEach((item) => item.classList.remove("hidden"));
        let element = this.querySelector(
          `.swiper-slide[data-handle="${this.selection.collection}"]`
        );

        let index_to_slide = [...element.parentNode.children].indexOf(element);

        this.querySelector(
          ".watch-configurator-footer__dials"
        ).classList.remove("modify");

        this.querySelector(
          ".watch-configurator-footer__strap"
        ).classList.remove("modify");

        // Update swiper and slide to the selected collection
        this.collectionSwiper.update();
        this.collectionSwiper.slideTo(index_to_slide, 0, false);

        // Add a class to the collection selection to specify that we are in the modify step
        this.querySelector(".watch-configurator__collection").classList.add(
          "watch-configurator__collection--modify"
        );

        // Update the footer
        this.querySelector(
          ".watch-configurator-footer__collection"
        ).classList.add("modify");

        // Add event slide change to select directly the center current collection
        this.collectionSwiper.on(
          "slideChange",
          function (slider) {
            let index = slider.activeIndex;
            this.collectionItems.forEach((item) =>
              item.classList.remove("selected")
            );
            // Add selected class to the current collection
            this.collectionItems[index].classList.add("selected");
            this.querySelectorAll(
              ".watch-configurator-footer__collection-list button[data-handle]"
            ).forEach((btn) => btn.classList.remove("selected"));
            this.querySelector(
              `.watch-configurator-footer__collection-list button[data-handle="${this.collectionItems[index].dataset.handle}"]`
            ).classList.add("selected");
          }.bind(this)
        );
        this.updateAddToCart(false);
      }
    });

    this.querySelectorAll('[data-action="select-collection:modify"]').forEach(
      (btn) =>
        btn.addEventListener("click", () => {
          let handle = btn.dataset.handle;
          this.querySelector(
            '.watch-configurator__collection-item[data-handle="' +
              handle +
              '"] button'
          ).click();

          btn.closest(".modify")
            ? btn.closest(".modify").classList.remove("modify")
            : null;
          this.querySelector(
            ".watch-configurator__collection"
          ).classList.remove("watch-configurator__collection--modify");

          this.updateDialsCollection();

          const mouseoverEvent = new Event("mouseover");

          this.querySelector(
            `.watch-configurator__collection-item.swiper-slide[data-handle="${handle}"]`
          ).dispatchEvent(mouseoverEvent);
        })
    );

    /** DIALS SELECTOR EVENTS **/

    this.querySelector(".watch-configurator-footer__dials").addEventListener(
      "click",
      () => {
        if (
          this.currentStep === "dial-selected" ||
          this.currentStep === "strap-selected"
        ) {
          this.alertPopinDials.classList.add("opened");
        } else {
          this.querySelectorAll(
            ".watch-configurator__view3 .watch-configurator-breadcrumb"
          ).forEach((item) => {
            item.classList.remove("hidden");
          });
          this.currentStep = "dial-modify";
          this.updateStep();
          this.querySelector(".watch-configurator__view1").classList.add(
            "hidden"
          );
          this.querySelector(".watch-configurator__view2").classList.remove(
            "hidden"
          );

          this.querySelector(".watch-configurator-footer__dials").classList.add(
            "modify"
          );

          // Remove class "modify" from the collection and strap buttons

          this.querySelector(
            ".watch-configurator-footer__strap"
          ).classList.remove("modify");

          this.querySelector(
            ".watch-configurator-footer__collection"
          ).classList.remove("modify");

          // this.querySelector('.watch-configurator__view3').classList.add('hidden');

          this.querySelectorAll(
            `[data-dial-collection][data-watch-collection]`
          ).forEach((dial) => {
            dial.classList.add("hidden");
            dial.classList.remove("swiper-slide");
          });

          let dial = this.querySelector(`
          .watch-configurator-footer__dials-list button.selected`).dataset.dial;

          this.querySelectorAll(
            `[data-dial-collection="${dial}"][data-watch-collection="${this.selection.collection}"]`
          ).forEach((dial) => {
            dial.classList.remove("hidden", "selected");
            dial.classList.add("swiper-slide");
          });

          this.dials_swiper.update();
          this.dials_swiper.slideTo(0);
          this.updateAddToCart(false);
        }
      }
    );

    this.querySelectorAll('button[data-action="select-dial:modify"]').forEach(
      (btn) =>
        btn.addEventListener("click", (e) => {
          let dial_collection = e.currentTarget.dataset.dial;
          this.querySelectorAll(
            'button[data-action="select-dial:modify"]'
          ).forEach((btn) => btn.classList.remove("selected"));
          e.currentTarget.classList.add("selected");

          this.querySelectorAll(
            `[data-dial-collection][data-watch-collection]`
          ).forEach((dial) => {
            dial.classList.add("hidden");
            dial.classList.remove("swiper-slide");
          });

          this.querySelectorAll(
            `[data-dial-collection="${dial_collection}"][data-watch-collection="${this.selection.collection}"]`
          ).forEach((dial) => {
            dial.classList.remove("hidden");
            dial.classList.add("swiper-slide");
          });

          this.dials_swiper.update();
          this.dials_swiper.slideTo(0);
        })
    );

    /** STRAP SELECTOR EVENTS **/

    this.querySelector(".watch-configurator-footer__strap").addEventListener(
      "click",
      () => {
        this.querySelectorAll(
          ".watch-configurator__view3 .watch-configurator-breadcrumb"
        ).forEach((item) => {
          item.classList.remove("hidden");
        });
        this.currentStep = "strap-modify";
        this.updateStep();

        this.querySelector(
          ".watch-configurator-footer__dials"
        ).classList.remove("modify");

        this.querySelector(
          ".watch-configurator-footer__collection"
        ).classList.remove("modify");

        this.querySelector(".watch-configurator-footer__strap").classList.add(
          "modify"
        );

        this.querySelectorAll(
          `[data-strap-collection][data-watch-collection]`
        ).forEach((strap) => {
          strap.classList.add("hidden");
          strap.classList.remove("swiper-slide");
        });

        let dial = this.querySelector(
          `.watch-configurator-footer__dials-list button.selected`
        ).dataset.dial;

        this.querySelectorAll(
          `[data-strap-collection="${dial}"][data-watch-collection="${this.selection.collection}"]`
        ).forEach((strap) => {
          strap.classList.remove("hidden");
          strap.classList.add("swiper-slide");
        });

        this.querySelector("[data-strap-family][data-action].selected").click();
        this.querySelector("[data-strap-size].selected")
          ? this.querySelector("[data-strap-size].selected").classList.remove(
              "selected"
            )
          : null;

        this.querySelectorAll("[data-additionnal-strap]").forEach((item) => {
          item.classList.add("hidden");
          item.classList.remove("swiper-slide");
        });

        // this.querySelector(
        //   ".watch-configurator-strap__html-to-inject--main"
        // ).classList.remove("hidden");

        this.querySelector(
          ".watch-configurator-strap__container"
        ).classList.remove("selected");

        this.querySelector(
          ".watch-configurator-strap > .overflow-strap"
        ).classList.remove("hidden");

        this.strap_swiper.update();
        this.strap_swiper.slideTo(0);
        this.updateAddToCart(false);
        if (
          this.currentStep == "strap-modify" &&
          !this.querySelector(
            ".watch-configurator-strap__container "
          ).classList.contains("additional-strap")
        ) {
          this.querySelector(
            ".watch-configurator-strap__html-to-inject--main"
          ).classList.remove("hidden");
        } else {
          this.querySelector(
            ".watch-configurator-strap__html-to-inject--main"
          ).classList.add("hidden");
        }
      }
    );

    this.querySelectorAll('button[data-action="select-strap:modify"]').forEach(
      (btn) =>
        btn.addEventListener("click", (e) => {
          if (this.isOpen) {
            this.querySelector(
              ".watch-configurator-alert-simple-loader-config"
            ).classList.add("opened", "opacity-20");
            this.querySelector(".watch-configurator__view3").setAttribute(
              "style",
              "opacity: 0.1"
            );
          }
          this.querySelectorAll(
            'button[data-action="select-strap:modify"]'
          ).forEach((btn) => btn.classList.remove("selected"));
          e.currentTarget.classList.add("selected");

          this.querySelectorAll(`[data-strap-family][data-strap-size]`).forEach(
            (strap) => {
              strap.classList.add("hidden");
              strap.classList.remove("swiper-slide");
            }
          );

          let family = e.currentTarget.dataset.strapFamily
            .replace(" 12mm", "")
            .replace(" 15mm", "")
            .replace(" 17mm", "");

          console.log(this.selection.collection_size);

          setTimeout(
            function () {
              this.sortSwiperSlideStrap(family, this.selection.collection_size);
            }.bind(this),
            100
          );

          this.querySelector(
            ".watch-configurator-strap__container"
          ).classList.remove("selected");

          this.strap_swiper.update();

          setTimeout(
            function () {
              this.strap_swiper.slideTo(0);
              window.dispatchEvent(new Event("resize"));
            }.bind(this),
            700
          );
        })
    );
  }

  updateDialsCollection() {
    let current_family = this.querySelector(
      '[data-action="select-dial:modify"].selected'
    ).dataset.dial;

    this.dialItems.forEach((item) => {
      if (
        this.selection.collection == item.dataset.watchCollection &&
        current_family == item.dataset.dialCollection
      ) {
        item.classList.remove("hidden");
        item.classList.add("swiper-slide");
      } else {
        item.classList.remove("selected");
        item.classList.add("hidden");
        item.classList.remove("swiper-slide");
      }
    });
  }

  updateStep() {
    this.querySelectorAll("[data-step]").forEach((step) => {
      step.classList.add("hidden");
    });

    this.querySelector(`[data-step="${this.currentStep}"]`).classList.remove(
      "hidden"
    );
  }

  closeAlertPopin() {
    this.alertPopin.classList.remove("opened");
    this.alertPopinDials.classList.remove("opened");
  }

  ResetToDials() {
    this.currentStep = "dial-modify";
    this.updateStep();

    this.querySelector(".watch-configurator__view1").classList.add("hidden");
    this.querySelector(".watch-configurator__view2").classList.remove("hidden");
    this.querySelector(".watch-configurator__view3").classList.add("hidden");

    this.querySelector(".watch-configurator-footer__dials").classList.add(
      "modify"
    );
    this.querySelector(".watch-configurator-footer__strap").classList.remove(
      "modify"
    );

    this.querySelector(".watch-configurator-footer__dials").classList.remove(
      "disabled"
    );
    this.querySelector(".watch-configurator-footer__strap").classList.add(
      "disabled",
      "events-none"
    );

    this.querySelector(".watch-configurator-strap__container").classList.remove(
      "selected"
    );

    this.querySelector(
      ".watch-configurator-strap > .overflow-strap"
    ).classList.remove("hidden");

    document
      .querySelectorAll('[data-action="additional:strap:remove"]')
      .forEach((item) => {
        item.click();
      });

    this.querySelector(
      ".watch-configurator-footer__dials-list-container button.selected"
    ).click();

    this.querySelectorAll("[data-additionnal-strap]").forEach((item) => {
      item.removeAttribute("data-strap-family");
    });

    this.closeAlertPopin();
  }

  ResetToCollection() {
    this.currentStep = "collection-modify";
    this.querySelector(".watch-configurator-footer__dials").classList.add(
      "events-none"
    );
    this.updateStep();

    this.querySelector(".watch-configurator__view1").classList.remove("hidden");
    this.querySelector(".watch-configurator__view2").classList.add("hidden");
    this.querySelector(".watch-configurator__view3").classList.add("hidden");

    this.querySelector(".watch-configurator-footer__dials").classList.remove(
      "modify"
    );
    this.querySelector(".watch-configurator-footer__strap").classList.remove(
      "modify"
    );

    this.querySelector(".watch-configurator-footer__dials").classList.add(
      "disabled"
    );
    this.querySelector(".watch-configurator-footer__strap").classList.add(
      "disabled",
      "events-none"
    );

    this.querySelector(".watch-configurator-strap__container").classList.remove(
      "selected"
    );

    document.querySelector(".watch-configurator-footer__collection").click();

    this.querySelector(
      ".watch-configurator-strap > .overflow-strap"
    ).classList.remove("hidden");

    document
      .querySelectorAll('[data-action="additional:strap:remove"]')
      .forEach((item) => {
        item.click();
      });

    this.querySelectorAll("[data-additionnal-strap]").forEach((item) => {
      item.removeAttribute("data-strap-family");
    });

    this.closeAlertPopin();
  }

  addStrap(e) {
    this.querySelector(".watch-configurator-footer__strap").click();
    this.currentStep = "strap-additionnal";
    this.currentStrapAdditionnal = e.currentTarget.closest(
      "[data-additionnal-strap]"
    ).dataset.additionnalStrap;
    this.querySelectorAll(
      ".watch-configurator-strap__container, .watch-configurator-footer"
    ).forEach((item) => {
      item.classList.add("additional-strap");
    });
    this.querySelector(".watch-configurator-popin").classList.add(
      "additionnal-strap"
    );
    this.strapItems = document.querySelectorAll(
      "[data-strap-color][data-strap-family]:not(.selected)"
    );
    this.strapItems.forEach((item) => {
      item.classList.remove("swiper-slide-active");
    });
    this.querySelector(
      ".watch-configurator-strap > .overflow-strap"
    ).classList.remove("hidden");
    this.querySelector(
      ".watch-configurator-strap__html-to-inject--main"
    ).classList.add("hidden");
    this.querySelector(
      ".watch-configurator-additional-strap--main"
    ).classList.remove("hidden");

    setTimeout(
      function () {
        this.strap_swiper.slideTo(0);
        window.dispatchEvent(new Event("resize"));
      }.bind(this),
      400
    );

    setTimeout(
      function () {
        this.strap_swiper.slideTo(0);
        window.dispatchEvent(new Event("resize"));
      }.bind(this),
      800
    );
  }

  selectAdditionalStrap(e) {
    this.querySelector(
      ".watch-configurator-alert-simple-loader-config"
    ).classList.add("opened");
    this.currentStep = "strap-selected";
    let strap_image = this.querySelector(
      "[data-strap-color].swiper-slide-active:not(.hidden) .watch-configurator-strap__strap-image img"
    ).getAttribute("src");
    this.selection.additionalStrap[this.currentStrapAdditionnal] = {
      color: e.currentTarget.closest("[data-strap-color]").dataset.strapColor,
      family: e.currentTarget.closest("[data-strap-family]").dataset
        .strapFamily,
      image: strap_image,
      sku: e.currentTarget
        .closest("[data-strap-color]")
        .dataset.strapSku.split(" + ")[0],
      price: parseInt(
        e.currentTarget.closest("[data-strap-color]").dataset.strapPrice
      ),
      clasp: {},
    };
    this.querySelectorAll(
      ".watch-configurator__view3 .watch-configurator-breadcrumb"
    ).forEach((item) => {
      item.classList.add("hidden");
    });
    console.log(this.selection.additionalStrap);
    let additionalStrapContainer = this.querySelector(
      '[data-additionnal-strap="' + this.currentStrapAdditionnal + '"]'
    );
    additionalStrapContainer.querySelector(
      ".watch-configurator-strap__strap-image img"
    ).src = strap_image;
    additionalStrapContainer.classList.add("strap-added");
    additionalStrapContainer.setAttribute(
      "data-strap-family",
      e.currentTarget.closest("[data-strap-family]").dataset.strapFamily
    );
    this.querySelectorAll(
      ".watch-configurator-strap__container, .watch-configurator-footer"
    ).forEach((item) => {
      item.classList.remove("additional-strap");
    });
    this.querySelector(".watch-configurator-footer__strap").classList.remove(
      "modify",
      "disabled"
    );
    this.querySelectorAll("[data-additionnal-strap]").forEach((item) => {
      item.classList.remove("hidden");
      item.classList.add("swiper-slide");
    });
    this.querySelector(".watch-configurator-strap__container").classList.add(
      "selected"
    );
    this.strapItems = document.querySelectorAll(
      "[data-strap-color][data-strap-family]"
    );
    this.strapItems.forEach((item) => {
      item.classList.remove(
        "swiper-slide",
        "swiper-slide-active",
        "swiper-slide-next",
        "swiper-slide-prev"
      );
      item.classList.add("hidden");
    });
    // this.querySelectorAll(
    //   ".watch-configurator-add-strap, [data-strap-size].selected"
    // ).forEach((item) => {
    //   item.classList.remove("hidden");
    //   item.classList.add("swiper-slide");
    // });
    this.strap_card_selected.classList.remove("hidden");
    this.strap_card_selected.classList.add("selected", "swiper-slide");
    this.strap_swiper.update();
    this.querySelector(
      ".watch-configurator-strap > .overflow-strap"
    ).classList.add("hidden");

    this.querySelector(".watch-configurator-popin").classList.remove(
      "additionnal-strap"
    );

    setTimeout(
      function () {
        if (window.innerWidth >= 990) {
          this.strap_swiper.slideTo(1);
          window.dispatchEvent(new Event("resize"));
        } else {
          let index = this.currentStrapAdditionnal == 1 ? 0 : 2;
          this.strap_swiper.slideTo(index);
          window.dispatchEvent(new Event("resize"));
        }
      }.bind(this),
      1500
    );

    let claspData = window.claspCollection.find(function (clasp) {
      let handle = document
        .querySelector("[data-dial].selected")
        .dataset.dial.toLowerCase()
        .replaceAll(" ", "-");
      let claspHandle = clasp.handle.replaceAll("configurateur-boucle-", "");
      console.log(claspHandle, handle);
      return claspHandle === handle;
    });

    let variant = claspData.variants[0];

    this.selection.additionalStrap[this.currentStrapAdditionnal].clasp = {
      metal: variant.title.split(" / ")[1],
      price: variant.price,
      variant_image: variant.featured_image ? variant.featured_image.src : null,
      sku: variant.sku,
    };

    console.log(this.selection);

    this.updateAdditionalStrapInfo();
    this.updateTotalPrice();
    this.updateAddToCart(true);
    this.querySelector(
      ".watch-configurator-strap__html-to-inject--main"
    ).classList.add("hidden");
    this.querySelector(
      ".watch-configurator-additional-strap--main"
    ).classList.add("hidden");

    // window.dispatchEvent(new Event("resize"));
    setTimeout(
      function () {
        window.dispatchEvent(new Event("resize"));
        this.querySelector(
          ".watch-configurator-alert-simple-loader-config"
        ).classList.remove("opened");
        window.dispatchEvent(new Event("resize"));
      }.bind(this),
      2500
    );
  }

  removeAdditionalStrap(e) {
    let strap = e.currentTarget.closest("[data-additionnal-strap]");
    strap.classList.remove("strap-added");
    this.selection.additionalStrap[strap.dataset.additionnalStrap] = null;
    this.strap_swiper.update();
    this.updateAdditionalStrapInfo();
    this.updateTotalPrice();
    this.querySelector(
      ".watch-configurator-strap__html-to-inject--main"
    ).classList.add("hidden");
    this.querySelector(
      ".watch-configurator-additional-strap--main"
    ).classList.add("hidden");
    strap.removeAttribute("data-strap-family");
  }

  cancelAdditionalStrap(e) {
    this.currentStep = "strap-selected";
    this.querySelector(
      ".watch-configurator-alert-simple-loader-config"
    ).classList.add("opened");
    this.querySelector(".watch-configurator-footer__strap").classList.remove(
      "modify",
      "disabled"
    );
    this.querySelectorAll("[data-additionnal-strap]").forEach((item) => {
      item.classList.remove("hidden");
      item.classList.add("swiper-slide");
    });
    this.querySelectorAll(
      ".watch-configurator__view3 .watch-configurator-breadcrumb"
    ).forEach((item) => {
      item.classList.add("hidden");
    });
    this.querySelector(
      '[data-step="strap-modify"] .overflow-strap'
    ).classList.add("hidden");
    this.querySelector(".watch-configurator-strap__container").classList.add(
      "selected"
    );
    this.querySelectorAll(
      ".watch-configurator-strap__container, .watch-configurator-footer"
    ).forEach((item) => {
      item.classList.remove("additional-strap");
    });

    this.querySelector(".watch-configurator-popin").classList.remove(
      "additionnal-strap"
    );
    this.strapItems = document.querySelectorAll(
      "[data-strap-color][data-strap-family]"
    );
    this.strapItems.forEach((item) => {
      item.classList.remove(
        "swiper-slide",
        "swiper-slide-active",
        "swiper-slide-next",
        "swiper-slide-prev"
      );
      item.classList.add("hidden");
    });

    this.querySelectorAll(
      ".watch-configurator-add-strap, [data-strap-size].selected"
    ).forEach((item) => {
      item.classList.remove("hidden");
      item.classList.add("swiper-slide");
    });

    this.strap_card_selected.classList.remove("hidden");
    this.strap_card_selected.classList.add("selected", "swiper-slide");
    this.strap_swiper.update();
    this.updateAddToCart(true);

    this.querySelectorAll(
      "[data-strap-color][data-strap-sku-simple].hidden"
    ).forEach((item) => {
      item.remove();
    });

    setTimeout(
      function () {
        this.strap_swiper.slideTo(1);
        // hide loader
        this.querySelector(
          ".watch-configurator-alert-simple-loader-config"
        ).classList.remove("opened", "opacity-20");

        this.querySelector("[data-strap-size].selected").click();
        window.dispatchEvent(new Event("resize"));
      }.bind(this),
      1100
    );

    this.querySelector(
      ".watch-configurator-strap__html-to-inject--main"
    ).classList.add("hidden");
    this.querySelector(
      ".watch-configurator-additional-strap--main"
    ).classList.add("hidden");
  }

  modifyAdditionalStrap(e) {
    let strap = e.currentTarget.closest("[data-additionnal-strap]");
    this.currentStrapAdditionnal = strap.dataset.additionnalStrap;
    this.addStrap(e);
    this.querySelector(
      ".watch-configurator-strap > .overflow-strap"
    ).classList.remove("hidden");
  }

  updateAdditionalStrapInfo(e) {
    let infosContainer = this.querySelector(
      "[data-strap-size].selected .watch-configurator-straps-details"
    );

    let new_html = infosContainer.querySelector("p:first-child").outerHTML;
    for (let i = 1; i < 3; i++) {
      if (this.selection.additionalStrap[i]?.family) {
        let price =
          this.selection.additionalStrap[i].price / 100 +
          this.selection.additionalStrap[i].clasp.price / 100;
        new_html +=
          "<p class='medium-text'>BRACELET " +
          this.selection.additionalStrap[i].family +
          " " +
          this.selection.additionalStrap[i].color;
        let new_data = "";

        if (
          this.selection.additionalStrap[i].family == "métal" ||
          this.selection.additionalStrap[i].family == "perles d'eau douce"
        ) {
          new_data = " - " + price + "€</p>";
        } else {
          new_data =
            ", BOUCLE ARDILLON EN " +
            this.selection.additionalStrap[i].clasp.metal +
            " - " +
            price +
            "€</p>";
        }
        new_html += new_data;
      }
    }
    infosContainer.innerHTML = new_html;
  }

  updateClaspData(claspData, claspDataAdditional) {
    let claspImages = this.querySelectorAll(
      `[data-strap-size="${this.selection.collection_size}"][data-strap-family]:not([data-additionnal-strap]) .watch-configurator-clasps__selected-image img`
    );

    let claspTitle = this.querySelectorAll(
      `[data-strap-size="${this.selection.collection_size}"][data-strap-family]:not([data-additionnal-strap]) .watch-configurator-clasps__selected-title`
    );

    let claspImageAdditionnal = this.querySelectorAll(
      "[data-additionnal-strap] .watch-configurator-clasps__selected-image img"
    );

    let claspTitleAdditionnal = this.querySelectorAll(
      "[data-additionnal-strap] .watch-configurator-clasps__selected-title"
    );

    this.querySelectorAll(
      "[data-strap-family]:not([data-additionnal-strap]) .watch-configurator-clasps__select-metal"
    ).forEach((item) => {
      item.classList.remove("hidden");
      item.classList.add("swiper-slide");
      if (!(item.dataset.clapsSize == this.selection.collection_size)) {
        item.classList.add("hidden");
        item.classList.remove("swiper-slide");
      }
    });

    console.log(`COLLECTION SIZE -> ${this.selection.collection_size}`);
    console.log(claspData);

    let variant = claspData.variants.find((variant2) => {
      return variant2.option1 == this.selection.collection_size;
    });

    if (variant) {
      claspImages.forEach((item) => {
        console.log(variant.featured_image);
        item.src = variant.featured_image ? variant.featured_image.src : null;
      });

      claspTitle.forEach((item) => {
        let title = `BOUCLE ${
          variant.title.split(" / ")[1]
        } <span>INCLUS</span>`;
        item.innerHTML = title;
      });

      for (const variant3 of claspData.variants) {
        let clasp = this.querySelectorAll(
          `[data-strap-size="${
            this.selection.collection_size
          }"] .watch-configurator-clasps__select-metal [data-clasp="${
            variant3.title.split(" / ")[1]
          }"]`
        ).forEach((item) => {
          let price = variant3.price / 100;
          item.innerHTML = `${price == 0 ? "INCLUS" : price + "€"}`;
        });
      }

      this.selection.strap.clasp = {
        metal: variant.title.split(" / ")[1],
        price: variant.price,
        variant_image: variant.featured_image
          ? variant.featured_image.src
          : null,
        sku: variant.sku,
      };

      this.querySelectorAll("[data-clasp-selected]").forEach((item) => {
        if (item.closest("[data-strap-family]")) {
          if (
            !(
              item.closest("[data-strap-family]").dataset.strapFamily == "métal"
            )
          ) {
            if (
              !(
                item.closest("[data-strap-family]").dataset.strapFamily ==
                "perles d'eau douce"
              )
            )
              item.innerHTML = `, BOUCLE ARDILLON EN ${this.selection.strap.clasp.metal}`;
          }
        }
      });

      this.querySelectorAll(
        "[data-additionnal-strap] .watch-configurator-clasps__select-metal"
      ).forEach((item) => {
        item.classList.remove("hidden");
        item.classList.add("swiper-slide");
        if (!(item.dataset.clapsSize == this.selection.collection_size)) {
          item.classList.add("hidden");
          item.classList.remove("swiper-slide");
        }
      });

      claspImageAdditionnal.forEach((item) => {
        item.src = variant.featured_image ? variant.featured_image.src : null;
      });

      claspTitleAdditionnal.forEach((item) => {
        let title = `BOUCLE ${
          variant.title.split(" / ")[1]
        } <span>INCLUS</span>`;
        item.innerHTML = title;
      });
    }
  }

  modifyClasp(e) {
    e.currentTarget
      .closest(".watch-configurator-clasps__selected")
      .classList.add("hidden");
    e.currentTarget
      .closest(".watch-configurator-clasps__selected")
      .nextElementSibling.classList.remove("hidden");
  }

  slideToClaps(e) {
    // let index = e.currentTarget.dataset.claspIndex;
    // this.clasp_swiper.slideTo(index);
  }

  selectClasp(e) {
    let metal =
      e.currentTarget.closest("[data-claps-metal]").dataset.clapsMetal;
    let price_html = e.currentTarget.previousElementSibling.innerHTML;
    console.log(price_html);
    if (price_html == "INCLUS") price_html = "0";
    let price =
      parseInt(price_html.replace("€", "").replaceAll(" ", "").trim()) * 100;
    let variant_image = e.currentTarget
      .closest("[data-claps-index]")
      .querySelector("img")
      .getAttribute("data-src");

    console.log(price);

    console.log(e.currentTarget.closest("[data-claps-metal]").dataset);

    this.selection.strap.clasp = {
      metal: metal,
      price: price,
      variant_image: variant_image,
      sku: e.currentTarget.closest("[data-claps-metal]").dataset.clapsSku,
    };

    this.querySelector(
      "[data-strap-size].selected [data-clasp-selected]"
    ).innerHTML = `, BOUCLE ARDILLON EN ${metal}`;

    let totalPrice =
      (this.selection.strap.price + this.selection.strap.clasp.price) / 100;

    console.log(this.selection.strap.price, this.selection.strap.clasp.price);

    this.querySelector(
      "[data-strap-size].selected .strap-included"
    ).innerHTML = ` -  ${totalPrice}€`;

    this.querySelector(
      "[data-strap-color].selected .watch-configurator-clasps__selected-image img"
    ).src = variant_image;

    this.querySelector(
      "[data-strap-color].selected .watch-configurator-clasps__selected-title"
    ).innerHTML = `BOUCLE ${metal} <span>${
      price == 0 ? "INCLUS" : price / 100 + "€"
    }</span>`;

    e.currentTarget
      .closest(".watch-configurator-clasps")
      .querySelector(".watch-configurator-clasps__selected")
      .classList.remove("hidden");
    e.currentTarget
      .closest(".watch-configurator-clasps")
      .querySelector(".watch-configurator-clasps__selected")
      .nextElementSibling.classList.add("hidden");

    console.log(this.selection);

    this.updateTotalPrice();
  }

  updateTotalPrice() {
    console.log(this.selection);
    let totalPrice = 0;

    totalPrice += this.selection.dialPrice / 100;
    totalPrice += this.selection.strap.price / 100;
    totalPrice += this.selection.strap.clasp.price / 100;

    if (this.selection.additionalStrap["1"] != null) {
      totalPrice += this.selection.additionalStrap["1"].clasp?.price
        ? this.selection.additionalStrap["1"].clasp.price / 100
        : 0;
      totalPrice += parseInt(this.selection.additionalStrap["1"].price) / 100;
    }

    if (this.selection.additionalStrap["2"] != null) {
      totalPrice += this.selection.additionalStrap["2"].clasp?.price
        ? this.selection.additionalStrap["2"].clasp.price / 100
        : 0;
      totalPrice += parseInt(this.selection.additionalStrap["2"].price) / 100;
    }

    console.log(totalPrice);

    this.selection.totalPrice = totalPrice;

    this.querySelector(
      ".selected[data-strap-family][data-strap-size] [data-c-price]"
    ).innerHTML = "TOTAL : " + totalPrice + "€";
  }

  selectAditionnalClasp(e) {
    let metal =
      e.currentTarget.closest("[data-claps-metal]").dataset.clapsMetal;
    let price_html = e.currentTarget.previousElementSibling.innerHTML.trim();
    if (price_html.trim() == "INCLUS") price_html = "0";
    let price = parseInt(price_html.replace("€", "")) * 100;
    let variant_image = e.currentTarget
      .closest("[data-claps-index]")
      .querySelector("img").src;

    let additional_index = e.currentTarget.closest("[data-additionnal-strap]")
      .dataset.additionnalStrap;

    this.selection.additionalStrap[additional_index].clasp = {
      metal: metal,
      price: price,
      variant_image: variant_image,
      sku: e.currentTarget.dataset.claspSku,
    };

    e.currentTarget
      .closest("[data-additionnal-strap]")
      .querySelector(".watch-configurator-clasps__selected-image img").src =
      variant_image;

    e.currentTarget
      .closest("[data-additionnal-strap]")
      .querySelector(
        ".watch-configurator-clasps__selected-title"
      ).innerHTML = `BOUCLE ${metal} <span>${
      price == 0 ? "INCLUS" : price / 100 + "€"
    }</span>`;

    e.currentTarget
      .closest(".watch-configurator-clasps")
      .querySelector(".watch-configurator-clasps__selected")
      .classList.remove("hidden");
    e.currentTarget
      .closest(".watch-configurator-clasps")
      .querySelector(".watch-configurator-clasps__selected")
      .nextElementSibling.classList.add("hidden");

    console.log(this.selection);
    this.updateAdditionalStrapInfo();
    this.updateTotalPrice();
  }

  mergeImages() {
    var img1 = document.getElementById("img1");
    var img2 = document.getElementById("img2");
    var canvas = document.getElementById("canvas");
    var context = canvas.getContext("2d");

    canvas.width = 433;
    canvas.height = 577;

    context.globalAlpha = 1.0;

    context.drawImage(img1, 0, 0, 433, 577);
    context.drawImage(img2, 0, 0, 433, 577);

    let fileb64 = document.getElementById("canvas").toDataURL();

    var data = new FormData();

    let file_name = (Math.random() + 1).toString(36).substring(7) + ".jpg";

    data.append("file_name", file_name);

    data.append("file", fileb64);

    this.mergedImageB64 = fileb64;

    return fileb64;
  }

  async addToCart() {
    let b64 = this.mergeImages();

    document
      .querySelector(".watch-configurator-alert-loader")
      .classList.add("opened");

    let progressBar = document.querySelector(
      ".watch-configurator-alert__loader__bar"
    );
    let value = 0;

    this.intervalProgress = setInterval(function () {
      if (value < 100) {
        value += 1;
        progressBar.style.width = value + "%";
      } else {
        clearInterval(this.intervalProgress);
      }
    }, 20);

    let price =
      (parseInt(this.selection.dialPrice) +
        parseInt(this.selection.strap.price) +
        parseInt(this.selection.strap.clasp.price)) /
      100;
    let data = {
      b64: b64.replace("data:image/png;base64,", ""),
      product: {
        title: `Montre ${this.selection.title} personnalisée`,
        published: true,
        vendor: "Poiray Paris",
        variants: [
          {
            option1: this.selection.dial,
            option2: this.selection.strap.sku,
            price: price,
          },
        ],
        tags: ["configurateur", "montre-configurateur"],
        options: [
          {
            name: "Cadran",
            values: [this.selection.dial],
          },
          {
            name: "Bracelet",
            values: [this.selection.strap.sku],
          },
        ],
        metafields: [
          {
            key: "hidden",
            value: 1,
            type: "number_integer",
            namespace: "seo",
          },
          {
            key: "selection",
            value: JSON.stringify(this.selection),
            type: "json",
            namespace: "custom",
          },
        ],
      },
    };
    let family = this.selection.strap.title.split("-")[0];
    console.log(this.selection);
    if (family != "métal" && family != "perles d'eau douce") {
      data.product.variants[0].option3 = this.selection.strap.clasp.sku;
      data.product.options.push({
        name: "Boucle",
        values: [this.selection.strap.clasp.sku],
      });
    }

    const url =
      "https://6jdanucpjd.execute-api.eu-west-3.amazonaws.com/dev/webhook/product";

    let response = await fetch(url, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    });

    let json = await response.json();

    console.log(json);

    clearInterval(this.intervalProgress);
    progressBar.style.width = "100%";

    let id1 = null;
    let id2 = null;

    if (this.selection.additionalStrap["1"] != null) {
      window.strapCollection.forEach((strap) => {
        if (
          strap.title.indexOf(this.selection.additionalStrap["1"].family) > -1
        ) {
          strap.variants.forEach((variant) => {
            if (
              this.selection.additionalStrap["1"].family != "métal" &&
              this.selection.additionalStrap["1"].family != "perles d'eau douce"
            ) {
              if (
                variant.option1 == this.selection.additionalStrap["1"].color &&
                variant.option2 == this.selection.collection_size &&
                variant.option3 ==
                  this.selection.additionalStrap["1"].clasp.metal
              ) {
                id1 = variant.id;
              }
            } else {
              if (
                variant.option1 == this.selection.additionalStrap["1"].color &&
                variant.option2 == this.selection.collection_size
              ) {
                id1 = variant.id;
              }
            }
          });
        }
      });
    }

    if (this.selection.additionalStrap["2"] != null) {
      window.strapCollection.forEach((strap) => {
        if (
          strap.title.indexOf(this.selection.additionalStrap["2"].family) > -1
        ) {
          strap.variants.forEach((variant) => {
            if (
              this.selection.additionalStrap["2"].family != "métal" &&
              this.selection.additionalStrap["2"].family != "perles d'eau douce"
            ) {
              if (
                variant.option1 == this.selection.additionalStrap["2"].color &&
                variant.option2 == this.selection.collection_size &&
                variant.option3 ==
                  this.selection.additionalStrap["2"].clasp.metal
              ) {
                id2 = variant.id;
              }
            } else {
              if (
                variant.option1 == this.selection.additionalStrap["2"].color &&
                variant.option2 == this.selection.collection_size
              ) {
                id2 = variant.id;
              }
            }
          });
        }
      });
    }

    let key = findGetParameter("key");

    removeQueryParams();

    if (key != null) {
      var url_update = "/cart/update.js";
      const update_label = "updates[" + key + "]=0";
      const body = update_label;

      let res = await fetch(url_update, {
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body,
      });

      document.querySelector('.sidecart-item[data-key="' + key + '"]').remove();

      res = await res.json();
    }

    document.querySelector("side-cart").dispatchEvent(
      new CustomEvent("cart:added", {
        detail: {
          items: [json.product.variants[0].id, id1, id2],
          selection: this.selection,
        },
      })
    );

    this.selection = {
      collection: null,
      strap: {},
      dial: null,
      strapOnlyPicture: null,
      clasp: null,
      additionalStrap: {
        1: null,
        2: null,
      },
    };

    this.currentStep = "collection-modify";
    this.querySelector(".watch-configurator-footer__collection").click();
    this.querySelector(".watch-configurator-footer").classList.add("hidden");
    this.querySelector(".watch-configurator-footer__strap").classList.add(
      "disabled",
      "events-none"
    );
    this.querySelector(".watch-configurator-footer__dials").classList.add(
      "disabled"
    );
    this.updateAddToCart(false);
  }

  async getCartJson() {
    let response = await fetch("/cart.js");
    let json = await response.json();

    return json;
  }

  openLoaderRetreiveData() {
    this.querySelector(".watch-configurator-alert-loader-config").classList.add(
      "opened"
    );
  }

  async checkIfHasSelection() {
    let id = findGetParameter("id");

    if (id) {
      this.querySelector(
        ".watch-configurator-alert-loader-config"
      ).classList.add("opened");

      let cart = await this.getCartJson();
      console.log(cart);
      let item = cart.items.find((item) => item.id == id);
      if (!item) return;
      let selection = item.properties._selection;
      console.log(selection);
      let clasp_sku = selection.strap.clasp.sku;
      this.selection = selection;
      this.selection.additionalStrap["1"] = null;
      this.selection.additionalStrap["2"] = null;
      this.openWatchConfigurator();
      this.querySelector(
        `[data-watch-title="${selection.title}"] [data-action="select-collection"]`
      ).click();
      setTimeout(
        function () {
          let collection_dial = document.querySelector(
            `.watch-configurator__view2 [data-variant-sku="${selection.dial}"][data-dial-collection]`
          ).dataset.dialCollection;

          this.querySelector(
            `[data-action="select-dial:modify"][data-dial="${collection_dial}"]`
          ).click();

          this.querySelector(
            `.watch-configurator__view2 [data-variant-sku="${selection.dial}"][data-dial-collection]`
          ).click();
          this.querySelectorAll(
            ".watch-configurator__view2 .swiper-wrapper [data-variant-title]"
          ).forEach((el) => {
            el.classList.remove("hidden");
            el.classList.add("swiper-slide");
          });
          console.log(
            `.watch-configurator__view2 [data-variant-sku="${selection.dial}"][data-dial-collection]`
          );
          setTimeout(
            function () {
              this.querySelector(
                `.watch-configurator__view2 [data-variant-sku="${selection.dial}"][data-dial-collection]`
              ).click();
              this.querySelector(
                `.watch-configurator__view2 [data-variant-sku="${selection.dial}"][data-dial-collection] [data-action="select-dial"]`
              ).click();
              setTimeout(
                function () {
                  console.log(
                    `SKU SIMPLE -> ${selection.strap.sku} ---- ${selection.strap.clasp.metal}`
                  );
                  let family =
                    this.selection.strap.title.split("-")[0] +
                    " " +
                    this.selection.collection_size;
                  document
                    .querySelector(
                      `[data-action="select-strap:modify"][data-strap-family="${family}"]`
                    )
                    .click();

                  setTimeout(
                    function () {
                      console.log(
                        `[data-strap-sku-simple="${selection.strap.sku}"][data-clasp="${this.selection.strap.clasp.metal}"] [data-action="select-strap"]`
                      );
                      this.querySelector(
                        `[data-strap-sku-simple="${selection.strap.sku}"][data-clasp="${this.selection.strap.clasp.metal}"] [data-action="select-strap"]`
                      ).click();

                      this.selection.strap.clasp.sku = clasp_sku;
                      this.querySelector(
                        `.watch-configurator-clasps__select [data-claps-sku="${selection.strap.clasp.sku}"] [data-action="clasp:select"]`
                      )
                        ? this.querySelector(
                            `.watch-configurator-clasps__select [data-claps-sku="${selection.strap.clasp.sku}"] [data-action="clasp:select"]`
                          ).click()
                        : null;
                      this.strap_swiper.slideTo(1, 0, false);
                      this.querySelector(
                        ".watch-configurator-alert-loader-config"
                      ).classList.remove("opened");
                      this.querySelector(
                        ".watch-configurator-alert-simple-loader-config"
                      ).classList.add("opened");
                      setTimeout(
                        function () {
                          this.strap_swiper.slideTo(1, 0, false);
                          window.dispatchEvent(new Event("resize"));
                          this.querySelector(
                            ".watch-configurator-alert-simple-loader-config"
                          ).classList.remove("opened");
                          this.strap_swiper.slideTo(1);
                        }.bind(this),
                        1000
                      );
                    }.bind(this),
                    400
                  );
                }.bind(this),
                400
              );
            }.bind(this),
            400
          );
        }.bind(this),
        300
      );
    }
  }
}

customElements.define("watch-configurator", WatchConfigurator);
